import moment from 'moment';
import * as actionType from './actionType';

export const initialState = {
  planType: [],
  templateType: [],
  templateName: [],
  manufacturer: [],
  quarter: '',
  requestScreenData: {},
  detailScrenData: {
    searchData: {},
    letterDetail: {},
    headerDetail: {},
  },
  errorMessages: {
    searchPage: [],
    detailPage: [],
  },
  extraState: {
    fullScreenView: {
      mfgTable: false,
      templateDetail: false,
    },
    fetchMfg: true,
    edit: false,
    tabs: 'Body',
    templeType: null,
    letterAction: null,
    disabledBtn: false,
    saveApiActive: false,
    printPdf: false,
    saveEdit: false,
    createLetterActive: false,
    customizeValue: '',
    saveActionType: 'Save',
    // addDefHeader: false,
  },
  getInvDetail: [],
  invoiceDetail: [],
  createLetterDetail: [],
  saveCreateLetterData: [],
  getLetterId: {},
  getupdateSendDate: {},
  toMailId: {},
  fromMailId: {},
  sendMail: {},
  pdfPreviewContent: [],
  pdfPreview: '',
  pdfDraftPreview: '',
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_DETAIL_DATA:
      return { ...state, detailScrenData: action.payload };
    case actionType.SEARCH_REQUEST_TAB:
      return { ...state, requestScreenData: action.requestScreen };
    case actionType.GET_TEMPLATE_TYPE_LIST_CREATE:
      return {
        ...state,
        templateType: action.templateType,
        planType: action.payload,
      };
    case actionType.GET_TEMPLATE_NAME_LIST:
      return { ...state, templateName: action.templateName };
    case actionType.GET_MANUFACTURER_DATA:
      return {
        ...state,
        manufacturer: action.manufacturer,
      };
    case actionType.GET_QUARTER_VALUE:
      return { ...state, quarter: action.payload };
    case actionType.GET_ERROR_MSG_CREATE_LETTER:
      return { ...state, errorMessages: action.payload };
    case actionType.SAVE_CREATE_LETTER_DATA_CREATE:
      return { ...state, saveCreateLetterData: action.payload };
    case actionType.GET_CREATE_TEMPLATE_EXTRA_STATE:
      return { ...state, extraState: action.payload };
    case actionType.FETCH_CREATE_LETTER_DETAIL_CREATE:
      return { ...state, detailScrenData: action.payload };
    case actionType.FETCH_CREATE_LETTER_DETAIL_DATA_CREATE:
      return { ...state, createLetterDetail: action.payload };
    case actionType.GET_TO_MAIL_ID_CREATE:
      return { ...state, toMailId: action.payload };
    case actionType.GET_FROM_MAIL_ID_CREATE:
      return { ...state, fromMailId: action.payload };
    case actionType.SEND_LETTER_BY_EMAIL_CREATE:
      return { ...state, sendMail: action.sendMail };
    case actionType.GET_INVOICE_DETAILS_BY_INVOICE_NUM_CREATE:
      return { ...state, invoiceDetail: action.invoiceDetail };
    case actionType.GET_INVOICE_DETAILS_BY_INVOICE_NUM_BEFOR_CREATE:
      return { ...state, getInvDetail: action.getInvDetail };
    case actionType.GET_PRINT_PREVIEW_CONTENT:
      return { ...state, pdfPreviewContent: action.pdfPreviewContent };
    case actionType.GET_PRINT_PREVIEW_CREATE:
      return { ...state, pdfPreview: action.pdfPreview };
    case actionType.GET_PREVIEW_DRAFT_PDF_CREATE:
      return { ...state, pdfDraftPreview: action.pdfDraftPreview };
    case actionType.CREATE_LETTER_CLEAR_REDUX_DATA:
      return action.payload ? action.payload : { ...initialState };
    default:
      return state;
  }
};
export default reducer;
